if (!customElements.get("progress-bar")) {
  customElements.define(
    "progress-bar",
    class ProgressBar extends HTMLElement {
      connectedCallback() {
        this.steps = this.querySelectorAll(".progress-bar__step");
        this.zone = this.closest(".progress-bar-zone");

        if (!this.zone) return;

        this.cartTotalCents = +this.zone.dataset.cartTotalCents || 0;
        this.targetUnits = +this.zone.dataset.targetUnits || 0;
        this.textLeftTemplate = this.zone.dataset.textLeft || "";
        this.textSuccess = this.zone.dataset.textSuccess || "";
        this.currency = this.zone.dataset.currency || "EUR";
        this.locale = this.zone.dataset.locale || "fr-FR";

        this.thresholdUnits = this.steps.length
          ? Math.max(
              ...Array.from(this.steps).map((s) => +s.dataset.amount || 0)
            )
          : 0;

        // No usable step → keep the zone visible but show only the
        // success message (bar filled, no progression to display).
        if (this.thresholdUnits <= 0) {
          const drag = this.querySelector(".progress-bar__bar--drag");
          if (drag) drag.style.width = "100%";
          const title = this.querySelector(".progress-bar__title");
          if (title) title.innerHTML = this.textSuccess;
          this.style.height = "85px";
          return;
        }

        // Bar visual max (in cents). Keep configured target if it leaves
        // headroom; otherwise fill exactly to the threshold so the success
        // state aligns with 100%.
        const thresholdCents = this.thresholdUnits * 100;
        this.barMaxCents = Math.max(this.targetUnits * 100, thresholdCents);
        this.barMaxUnits = this.barMaxCents / 100;
        this.dataset.target = this.barMaxUnits;

        this.updateProgress(thresholdCents);
        this.updateTitle(thresholdCents);
        this.handleStepsPlacement();
        this.applyMaxHeight();

        this.querySelectorAll(".progress-bar__step img").forEach((img) => {
          if (!img.complete) {
            img.addEventListener("load", () => this.applyMaxHeight(), {
              once: true,
            });
          }
        });
      }

      updateProgress(thresholdCents) {
        const drag = this.querySelector(".progress-bar__bar--drag");
        if (!drag) return;
        const pct = Math.min(
          100,
          (this.cartTotalCents * 100) / this.barMaxCents
        );
        drag.style.width = `${pct}%`;
      }

      updateTitle(thresholdCents) {
        const title = this.querySelector(".progress-bar__title");
        if (!title) return;
        const leftCents = thresholdCents - this.cartTotalCents;
        if (leftCents > 0) {
          const formatted = this.formatMoney(leftCents);
          title.innerHTML = this.textLeftTemplate.replace(
            "€",
            `<strong>${formatted}</strong>`
          );
        } else {
          title.innerHTML = this.textSuccess;
        }
      }

      formatMoney(cents) {
        try {
          return new Intl.NumberFormat(this.locale, {
            style: "currency",
            currency: this.currency,
          }).format(cents / 100);
        } catch {
          return `${(cents / 100).toFixed(2)} €`;
        }
      }

      handleStepsPlacement() {
        this.steps.forEach((element) => {
          const amount = +element.dataset.amount || 0;
          const left = (amount * 100) / this.barMaxUnits;
          element.style.left = `${left}%`;
        });
      }

      applyMaxHeight() {
        const heights = Array.from(this.steps).map((el) => el.offsetHeight);
        const maxHeight = heights.length ? Math.max(...heights) : 0;
        this.style.height = `${85 + maxHeight}px`;
      }
    }
  );
}
